// src/components/Navbar.js
import React, { useState } from 'react';
import Logo from '../assets/111.jpg';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 50, // Adjust offset as needed for fixed header
        behavior: 'smooth'
      });
      setIsOpen(false); // Close mobile menu after clicking a link
    } else {
      window.location.href = `/#${id}`;
      setIsOpen(false);
    }
  };

  return (
    <nav className="flex justify-between items-center bg-white py-4 px-4 shadow-md fixed w-full top-0 left-0 z-50 font-normal">
      <div className="flex items-center flex-shrink-0">
        <a href="#giris" onClick={(e) => { e.preventDefault(); scrollToSection('giris'); }} className="flex items-center">
          {/* Change h-8 to a larger value, e.g., h-12 or h-16 */}
          <img src={Logo} alt="Panolux Logo" className="h-16 w-20 mr-2" /> 
        </a>
      </div>

      {/* Desktop Menu */}
      <ul className="hidden md:flex space-x-6 text-sm font-normal">
        <li>
          <a
            href="#giris"
            onClick={(e) => { e.preventDefault(); scrollToSection('giris'); }}
            className="text-gray-700 hover:text-emerald-600 transition duration-300"
          >
            GİRİŞ
          </a>
        </li>
        <li>
          <a
            href="#hakkimizda"
            onClick={(e) => { e.preventDefault(); scrollToSection('hakkimizda'); }}
            className="text-gray-700 hover:text-emerald-600 transition duration-300"
          >
            HAKKIMIZDA
          </a>
        </li>
        <li>
          <a
            href="#ozellikler"
            onClick={(e) => { e.preventDefault(); scrollToSection('ozellikler'); }}
            className="text-gray-700 hover:text-emerald-600 transition duration-300"
          >
            ÖZELLİKLER
          </a>
        </li>
        <li>
          <a
            href="#projeler"
            onClick={(e) => { e.preventDefault(); scrollToSection('projeler'); }}
            className="text-gray-700 hover:text-emerald-600 transition duration-300"
          >
            PROJELER
          </a>
        </li>
        <li>
          <a
            href="#yayindan"
            onClick={(e) => { e.preventDefault(); scrollToSection('yayindan'); }}
            className="text-gray-700 hover:text-emerald-600 transition duration-300"
          >
            YAYINDAN
          </a>
        </li>
        <li>
          <a
            href="#iletisim"
            onClick={(e) => { e.preventDefault(); scrollToSection('iletisim'); }}
            className="text-gray-700 hover:text-emerald-600 transition duration-300"
          >
            İLETİŞİM
          </a>
        </li>
      </ul>

      {/* Hamburger Icon for Mobile (remains the same) */}
      <div className="md:hidden flex items-center">
        <button
          onClick={toggleMenu}
          className="text-gray-700 focus:outline-none focus:text-blue-600"
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
        >
          {isOpen ? (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          )}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-40 md:hidden"
          onClick={toggleMenu}
        ></div>
      )}

      {/* Mobile Menu */}
      <div
        className={`fixed top-0 right-0 h-full bg-white w-64 shadow-lg transform transition-transform duration-300 ease-in-out z-50 md:hidden font-extralight ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="p-4 flex justify-end">
          <button
            onClick={toggleMenu}
            className="text-gray-700 focus:outline-none focus:text-blue-600"
            aria-label="Close navigation menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <ul className="flex flex-col p-4 space-y-4 text-base font-extralight">
          <li>
            <a
              href="#giris"
              onClick={(e) => { e.preventDefault(); scrollToSection('giris'); toggleMenu(); }}
              className="block text-gray-700 hover:text-emerald-600 transition duration-300 py-4"
            >
              GİRİŞ
            </a>
          </li>
          <li>
            <a
              href="#hakkimizda"
              onClick={(e) => { e.preventDefault(); scrollToSection('hakkimizda'); toggleMenu(); }}
              className="block text-gray-700 hover:text-emerald-600 transition duration-300 py-4"
            >
              HAKKIMIZDA
            </a>
          </li>
          <li>
            <a
              href="#ozellikler"
              onClick={(e) => { e.preventDefault(); scrollToSection('ozellikler'); toggleMenu(); }}
              className="block text-gray-700 hover:text-emerald-600 transition duration-300 py-4"
            >
              ÖZELLİKLER
            </a>
          </li>
          <li>
            <a
              href="#projeler"
              onClick={(e) => { e.preventDefault(); scrollToSection('projeler'); toggleMenu(); }}
              className="block text-gray-700 hover:text-emerald-600 transition duration-300 py-4"
            >
              PROJELER
            </a>
          </li>
          <li>
            <a
              href="#yayindan"
              onClick={(e) => { e.preventDefault(); scrollToSection('yayindan'); toggleMenu(); }}
              className="block text-gray-700 hover:text-emerald-600 transition duration-300 py-4"
            >
              YAYINDAN
            </a>
          </li>
          <li>
            <a
              href="#iletisim"
              onClick={(e) => { e.preventDefault(); scrollToSection('iletisim'); toggleMenu(); }}
              className="block text-gray-700 hover:text-emerald-600 transition duration-300 py-4"
            >
              İLETİŞİM
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;